/** @module SpecificationSourcing/SRLineItemPackageRenderer */
define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "csi/def/Action",
    "csi/def/ViewRef",
    "csi/heading/Ref",
    "csi",
    "csi/xml",
    "csi/xml/Query"
], function(declare,lang,Action,ViewRef,Ref,csi,xml,Query) {

    return declare(Ref, {

        /**
         * @override
         *
         * If the Data Package Template selected on the Supplier Request has IsSupplierSpecific set to true
         * then filter the drop down of Data Packages on the style by all Data Packages that
         * have ForProductSource set to empty or ForProductSource set to the supplier selected on the supplier request.
         */
        _getStoreAction: function(/*Context*/ctx, /*Heading*/h) {
            var action = this.inherited(arguments);

            var supplierRequest = ctx.getParent();
            if (!supplierRequest) {
                return action;
            }

            var dataPackageTemplateURL = supplierRequest.SRDPTemplate;
            if (!dataPackageTemplateURL || dataPackageTemplateURL == csi.EMPTY_URL) {
                return action;
            }

            var dataPackageTemplate = ctx.cache.getNode(dataPackageTemplateURL);
            if (!dataPackageTemplate.IsSupplierSpecific)
                return action;

            var q = new Query();
            if (supplierRequest.SRSuppliers && supplierRequest.SRSuppliers.length > 0) {
                var supplierURL = supplierRequest.SRSuppliers[0];

                q.Or()
                .RefAttr("Supplier", xml.OP_EQUALS, supplierURL, "Child:ForProductSource")
                .RefAttr("ForProductSource", xml.OP_EQUALS, csi.EMPTY_URL);

            } else {
                q.RefAttr("ForProductSource", xml.OP_EQUALS, csi.EMPTY_URL);
            }

            return lang.mixin(new Action(), {
                m_fixedQuery: q,
                m_viewRef: lang.mixin(new ViewRef(), {
                    m_id: "DataPackages",
                    m_path: "Child:SRLineItemProduct"
                })
            });

            return action;
        }

    });
});